import React from 'react';
import { Modal } from "reactstrap";

export default function  ModalMessageConfirm(props) {

    /**
     * Get properties
     */
    const { modal, toggle, message, callback } = props;

    return (
        <Modal
            isOpen = { modal }
            toggle = { toggle }
            className="modal modal-message"
        >
            <div className="text-center message">{message}</div>
            <div className="group-button text-center">
                <button className="btn btn-sm btn_cancel" onClick={ toggle }>キャンセル</button>
                <button className="btn btn-sm" onClick={ callback }>OK</button>
            </div>
        </Modal>
    );
}